import React, { useEffect } from 'react';
import FormGroup from '@material-ui/core/FormGroup';
import FormControlLabel from '@material-ui/core/FormControlLabel';
import Switch from '@material-ui/core/Switch';
import useLocalAudioToggle from '../../hooks/useLocalAudioToggle/useLocalAudioToggle';
import useLocalVideoToggle from '../../hooks/useLocalVideoToggle/useLocalVideoToggle';

export default function EntryMediaSwitch() {
  const [isAudioEnabled, toggleAudioEnabled] = useLocalAudioToggle();
  const [isVideoEnabled, toggleVideoEnabled] = useLocalVideoToggle();

  const [state, setState] = React.useState({
    checkedAudio: isAudioEnabled,
    checkedVideo: isVideoEnabled,
  });

  const handleChange = (event: React.ChangeEvent<HTMLInputElement>) => {
    setState({ ...state, [event.target.name]: event.target.checked });
  };

  useEffect(() => {
    setState({ ...state, checkedAudio: isAudioEnabled, checkedVideo: isVideoEnabled });
  }, [isVideoEnabled, isAudioEnabled]);

  return (
    <FormGroup row>
      <FormControlLabel
        control={
          <Switch
            checked={state.checkedAudio}
            onChange={e => {
              handleChange(e);
              toggleAudioEnabled();
            }}
            name="checkedA"
          />
        }
        label="Audio"
      />
      <FormControlLabel
        control={
          <Switch
            checked={state.checkedVideo}
            onChange={e => {
              handleChange(e);
              toggleVideoEnabled();
            }}
            name="checkedB"
          />
        }
        label="Video"
      />
    </FormGroup>
  );
}
